<mat-card >
  <mat-card-header>
    <div mat-card-avatar><i class="fa fa-cog fa-2x"></i></div>
    <mat-card-title>Información de Facturación</mat-card-title>
    <mat-card-subtitle>Ingrese los requisitos para el sistema de facturación</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <mat-card-subtitle class="subtitle">General</mat-card-subtitle>
      <div class="form-row">
        <mat-form-field>
          <mat-label>RUT de la empresa</mat-label>
          <input matInput appIdentifier placeholder="RUT de la empresa" formControlName="rut" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Razón Social</mat-label>
          <input matInput placeholder="Razón Social" formControlName="company_name" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Giro</mat-label>
          <input matInput placeholder="Giro" formControlName="activity" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Ciudad</mat-label>
          <input matInput placeholder="Ciudad" formControlName="city" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Comuna</mat-label>
          <input matInput placeholder="Comuna" formControlName="district" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Dirección</mat-label>
          <input matInput placeholder="Dirección" formControlName="address" autocomplete="off">
        </mat-form-field>
      </div>

      <div class="subtitle">Representante Legal</div>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Nombres y Apellidos</mat-label>
          <input matInput placeholder="Nombres y Apellidos" formControlName="legal_representative_name" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>RUT del representante</mat-label>
          <input matInput appIdentifier placeholder="RUT del representante" formControlName="legal_representative_rut" autocomplete="off">
        </mat-form-field>
      </div>

      <mat-card-subtitle class="subtitle">Cédula de identidad (Frontal)</mat-card-subtitle>
      <app-file-input [control]="form.get('rut_front_url') | formGroup"></app-file-input>

      <mat-card-subtitle class="subtitle">Cédula de identidad (Reverso)</mat-card-subtitle>
      <app-file-input [control]="form.get('rut_back_url') | formGroup"></app-file-input>

      <mat-card-subtitle class="subtitle">Firma Electronica</mat-card-subtitle>
      <app-file-input [control]="form.get('electronic_signature_url') | formGroup"></app-file-input>

    </form>
  </mat-card-content>

  <div mat-card-footer class="footer">
    <button mat-raised-button class="primary" (click)="saveForm()" [disabled]="!form.valid || saving() ">
      Guardar
    </button>
  </div>

</mat-card>